import { PawPrint, Users } from "lucide-react";
import shareCardBg from "@/assets/share-card-bg.png";

interface Props {
  backgroundDataUrl?: string;
}

/**
 * Story 7: Społeczność - razem tworzymy coś większego, liczby rosną
 */
export const InstagramStoryShare7 = ({ backgroundDataUrl }: Props) => {
  const bgImage = backgroundDataUrl || shareCardBg;

  return (
    <div
      style={{
        width: "1080px",
        height: "1920px",
        fontFamily: "'Nunito', sans-serif",
        display: "flex",
        flexDirection: "column",
        position: "relative",
        overflow: "hidden",
        backgroundColor: "#1a3a2a",
      }}
    >
      {/* Background image */}
      <img
        src={bgImage}
        alt=""
        draggable={false}
        data-export-bg="true"
        loading="eager"
        decoding="sync"
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          objectFit: "cover",
          zIndex: 0,
        }}
      />

      {/* Top accent */}
      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          height: "8px",
          background: "linear-gradient(90deg, #4E8A6E 0%, #6BAF8D 50%, #4E8A6E 100%)",
          zIndex: 2,
        }}
      />

      {/* Content */}
      <div
        style={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          padding: "200px 80px",
          position: "relative",
          zIndex: 1,
        }}
      >
        {/* Community icon */}
        <div
          style={{
            background: "rgba(78, 138, 110, 0.15)",
            borderRadius: "50%",
            width: "130px",
            height: "130px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            marginBottom: "48px",
          }}
        >
          <Users style={{ width: "64px", height: "64px", color: "#4E8A6E" }} />
        </div>

        {/* Main headline */}
        <h1
          style={{
            fontSize: "84px",
            fontWeight: 800,
            color: "#2D5A3D",
            margin: "0 0 24px",
            textAlign: "center",
            lineHeight: 1.15,
          }}
        >
          Im nas więcej,
          <br />
          tym więcej
          <br />
          pomagamy
        </h1>

        {/* Divider */}
        <div
          style={{
            width: "100px",
            height: "6px",
            background: "#4E8A6E",
            borderRadius: "3px",
            margin: "32px 0",
          }}
        />

        {/* Subtitle */}
        <p
          style={{
            fontSize: "44px",
            fontWeight: 600,
            color: "#4A7A5E",
            margin: "0 0 56px",
            textAlign: "center",
            lineHeight: 1.45,
            maxWidth: "900px",
          }}
        >
          Budujemy społeczność ludzi,
          <br />
          którym nie jest wszystko jedno.
          <br />
          Dołącz i zaproś znajomych.
        </p>

        {/* Growth visual - 3 cards */}
        <div
          style={{
            display: "flex",
            gap: "24px",
            marginBottom: "64px",
          }}
        >
          {[
            { emoji: "1️⃣", text: "Ty pomagasz" },
            { emoji: "🔗", text: "Udostępniasz" },
            { emoji: "💚", text: "Pomagamy razem" },
          ].map((item, i) => (
            <div
              key={i}
              style={{
                background: "rgba(255,255,255,0.95)",
                borderRadius: "24px",
                padding: "28px 24px",
                textAlign: "center",
                boxShadow: "0 4px 16px rgba(0,0,0,0.06)",
                width: "270px",
              }}
            >
              <p style={{ fontSize: "48px", margin: "0 0 12px" }}>{item.emoji}</p>
              <p
                style={{
                  fontSize: "28px",
                  fontWeight: 700,
                  color: "#2D5A3D",
                  margin: 0,
                  lineHeight: 1.3,
                }}
              >
                {item.text}
              </p>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div
          style={{
            background: "#4E8A6E",
            borderRadius: "50px",
            padding: "24px 56px",
          }}
        >
          <p
            style={{
              fontSize: "36px",
              fontWeight: 700,
              color: "#FFFFFF",
              margin: 0,
            }}
          >
            Prześlij znajomym 💚
          </p>
        </div>
      </div>

      {/* Footer */}
      <div
        style={{
          padding: "0 80px 100px",
          display: "flex",
          justifyContent: "center",
          position: "relative",
          zIndex: 1,
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: "14px" }}>
          <div
            style={{
              background: "#4E8A6E",
              borderRadius: "14px",
              width: "52px",
              height: "52px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <PawPrint style={{ width: "28px", height: "28px", color: "#FFFFFF" }} />
          </div>
          <span style={{ fontSize: "28px", fontWeight: 700, color: "#2D5A3D" }}>
            gdzieschronisko.pl
          </span>
        </div>
      </div>
    </div>
  );
};
